// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__2F4qB","Open":"SideDrawer_Open__2NdIB","Close":"SideDrawer_Close__1lF3j","Logo":"SideDrawer_Logo__2Whp-"};